import MyResponsivePie from "../PieChart";

const EventRateChart = ({ results = [] }) => {
  let veryPoor = 0, poor = 0, good = 0, veryGood = 0, excellent = 0;

  results.forEach(result => {
    const rate = parseInt(result.rate);

    if (rate === 1) veryPoor++;
    if (rate === 2) poor++;
    if (rate === 3) good++;
    if (rate === 4) veryGood++;
    if (rate === 5) excellent++;
  });


  const data = [
    {
      "id": "Very Poor",
      "label": "Very Poor",
      "value": veryPoor,
      "color": "hsl(167, 70%, 50%)"
    },
    {
      "id": "Poor",
      "label": "Poor",
      "value": poor,
      "color": "hsl(76, 70%, 50%)"
    },
    {
      "id": "Good",
      "label": "Good",
      "value": good,
      "color": "hsl(305, 70%, 50%)"
    },
    {
      "id": "Very Good",
      "label": "Very Good",
      "value": veryGood,
      "color": "hsl(77, 70%, 50%)"
    },
    {
      "id": "Excellent",
      "label": "Excellent",
      "value": excellent,
      "color": "hsl(67, 70%, 50%)"
    }
  ];

  return <MyResponsivePie data={data} />;
}

export default EventRateChart;
